<template>
  <div id>
    <!-- 视频弹框 -->
    <div class="sp-tan hide">
      <video id="myVideo" class="video-js">
        <source type="video/mp4" src="//img.haoyunba.com/tjmy.mp4" />您的浏览器不支持Video标签。
      </video>
      <button @click="closeTan()">关闭</button>
    </div>
    <div class="sp-tan-back hide" @click="closeTan()"></div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: "演示"
  },
  name: "app",
  data() {
    return {
      msg: "演示",
      videoUrl: this.url
    };
  },
  mounted() {
    // this.initVideo();
  },
  methods: {
    closeTan() {
      console.log("子组件");
      $(".sp-tan").css("display", "none");
      $(".sp-tan-back").css("display", "none");
      let vdo = document.getElementById("myVideo");
      vdo.src = "";
    },

    openTan(url) {
      console.log("子组件url:" + url);
      let vdo = document.getElementById("myVideo");
      url = url.replace("http:", "");
      vdo.src = url;
      this.initVideo(url);

      $(".sp-tan").css("display", "block");
      $(".sp-tan-back").css("display", "block");
    },

    initVideo(url) {
      //初始化视频方法
      let myPlayer = this.$video(myVideo, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: false,
        //自动播放属性,muted:静音播放
        autoplay: "muted",
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        // //设置视频播放器的显示宽度（以像素为单位）
        // width: "",
        // //设置视频播放器的显示高度（以像素为单位）
        // height: "700px"
      });

      myPlayer.src({ type: "video/mp4", src: url });
    }
  },
  components: {}
};
</script>
<style  scoped>
.sp-tan {
  position: fixed;
  z-index: 9999;
  top: 20%;
  margin: 0 auto;
  position: fixed;
  width: 80%;
  height: 700px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  z-index: 99999;
  margin: 0 10% 0 10%;
}
.video-js {
  width: 100%;
  height: 100%;
}
.vjs-tech {
  width: 100%;
  height: 100%;
}

.sp-tan-back {
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 9998;
  overflow: hidden;
}

.sp-tan button {
  width: 40%;
  height: 80px;
  background: rgba(21, 123, 250, 1);
  border-radius: 20px;
  border: none;
  font-size: 36px;
  color: rgba(255, 255, 255, 1);
  margin: 40px 15px 0 0;
}

.hide {
  display: none;
}

.open {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/common/video.vue